<template>
  <span>
    <a v-if="!isPatient && isActive && belongsToCurrentBranch && canEditRecords && !shortVersion"
       :title="!expanded ? $t('edit_visit') : ''"
       @click="quickView(false)"
       v-b-tooltip.hover
       class="data-table-action">
    <MenuViewSvg class="svg-size-md"/><span class="action-button-mob-title">{{ $t('edit_visit') }}</span>
  </a>
  <router-link
      v-if="!isPatient && isActive && belongsToCurrentBranch && object.client_id"
      :title="!expanded ? $t('fill_treatment') : ''"
      v-b-tooltip.hover
      class="data-table-action"
      :to="{name: 'PatientVisitPage', params: { visitid: object.id, id: object.client_id, page: 'teeth' } }">
    <EditSvg class="svg-stroke-light svg-size-lg"/><span class="action-button-mob-title">{{ $t('fill_treatment') }}</span>
  </router-link>
    <a class="data-table-action"
       v-if="!isPatient && rights.includes('accept_payments') && isActive && belongsToCurrentBranch && !shortVersion"
       :title="!expanded ? $t('payment') : ''"
       v-b-tooltip.hover
       @click="payment">
      <DollarSvg class="svg-light"/><span class="action-button-mob-title">{{ $t('payment') }}</span>
    </a>
    <a class="data-table-action"
       v-if="!isPatient && rights.includes('agreements') && isActive && belongsToCurrentBranch && !shortVersion"
       @click="agreementPressed"
       :title="!expanded ? $t('agreement') : ''"
       v-b-tooltip.hover>
      <ContractSvg/><span class="action-button-mob-title">{{ $t('agreement') }}</span>
    </a>
    <a class="data-table-action"
       :title="!expanded ? $t('print') : ''"
       v-if="isActive && object.client_id"
       v-b-tooltip.hover
       @click="printVisit">
      <PrintSvg class="svg-light"/><span class="action-button-mob-title">{{ $t('print') }}</span>
    </a>
    <a class="data-table-action"
       v-if="rights.includes('online_booking') && !shortVersion"
       :title="!expanded ? $t('links') : ''"
       v-b-tooltip.hover
       @click="onlineBookingLinks"
    >
      <LinkSvg class="svg-light svg-size-lg"/><span class="action-button-mob-title">{{ $t('links') }}</span>
    </a>
    <a class="data-table-action"
       v-if="rights.includes('visit_review') && shortVersion"
       :title="!expanded ? (object.reviewed_at ? $t('remove_confirmation') : $t('confirm')) : ''"
       v-b-tooltip.hover
       @click="toggleReview"
    >
      <BlockSvg class="svg-size-lg" v-if="object.reviewed_at"/>
      <ConfirmSvg class="svg-light svg-size-lg" v-else/>
      <span class="action-button-mob-title">{{ object.reviewed_at ? $t('remove_confirmation') : $t('confirm') }}</span>
    </a>
    <a class="data-table-action"
       v-if="object.id && isActive && belongsToCurrentBranch && !shortVersion"
       :title="!expanded ? $t('akt_print') : ''"
       v-b-tooltip.hover
       @click="openAktOptionsModal"
    >
      <NoteSvg/><span class="action-button-mob-title">{{ $t('akt_print') }}</span>
    </a>
    <!--    <b-dropdown right-->
    <!--                v-if="object.id && isActive && belongsToCurrentBranch"-->
    <!--                variant="link"-->
    <!--                no-caret-->
    <!--                toggle-tag="span"-->
    <!--                toggle-class="action-0"-->
    <!--                class="data-table-action">-->
    <!--      <template #button-content>-->
    <!--        <a v-b-tooltip.hover :title="$t('akt_print')">-->
    <!--          <NoteSvg/><span class="action-button-mob-title">{{ $t('akt_print') }}</span>-->
    <!--        </a>-->
    <!--      </template>-->
    <!--          <b-dropdown-item @click="printAkt('admin')">{{ $t('manager') }}</b-dropdown-item>-->
    <!--          <b-dropdown-item @click="printAkt('doctor')">{{ $t('doctor') }}</b-dropdown-item>-->
    <!--          <b-dropdown-item @click="printAkt('director')">{{ $t('director') }}</b-dropdown-item>-->
    <!--    </b-dropdown>-->
    <a class="data-table-action"
       :title="!expanded ? (isActive ? $t('cancel') : $t('restore')) : ''"
       v-b-tooltip.hover
       v-if="belongsToCurrentBranch && canDelete && !shortVersion"
       @click="cancelRecoverVisit">
      <DeleteSvg v-if="isActive" class="svg-stroke-light"/><RestoreSvg v-if="!isActive" class="svg-light"/><span class="action-button-mob-title">{{ isActive ? $t('cancel') : $t('restore') }}</span>
    </a>
    <OptionsPopup v-if="optionsModalOpen"
                  :title="$t('choose_signer')"
                  @changed="modalResolve"
                  :options="signerOptions"/>
    <AktOptionsPopup v-if="aktOptionsModalOpen"
                     :default-date="object.start"
                     @changed="modalResolve"/>
    </span>
</template>

<script>
import EditSvg from '@/assets/svg-vue/general/edit2.svg'
import PrintSvg from '@/assets/svg-vue/general/print2.svg'
import ContractSvg from '@/assets/svg-vue/patients/contract.svg'
import DollarSvg from '@/assets/svg-vue/patients/dollar.svg'
import NoteSvg from '@/assets/svg-vue/header/note.svg'
import DeleteSvg from '@/assets/svg-vue/general/delete2.svg'
import LinkSvg from '@/assets/svg-vue/general/link.svg'
import RestoreSvg from '@/assets/svg-vue/accounting/back.svg'
import MenuViewSvg from '@/assets/svg-vue/calendar/menu_view.svg'
import ConfirmSvg from '@/assets/svg-vue/form/tick.svg'
import BlockSvg from "@/assets/svg-vue/general/block.svg"
import JwtService from "@/services/jwt.service"
import {mapActions, mapState} from "vuex"
import {CalendarService} from "@/services/api/calendar.api.service"
import OptionsPopup from "@/components/parts/general/OptionsPopup.vue"
import AktOptionsPopup from "@/components/parts/patients/AktOptionsPopup.vue"
import {EloquentService} from "@/services/api/eloquent.api.service"
import moment from "moment/moment"
import {copyObject} from "@/extensions/prototypes/prototypes"

export default {
  name: "PatientDatatableRecordActions",
  inject: ['showReasonPrompt'],
  components: {
    OptionsPopup,
    EditSvg,
    ContractSvg,
    DollarSvg,
    PrintSvg,
    NoteSvg,
    DeleteSvg,
    LinkSvg,
    RestoreSvg,
    ConfirmSvg,
    BlockSvg,
    // EyeSvg,
    MenuViewSvg,
    AktOptionsPopup
  },
  props: {
    object: {
      type: Object
    },
    expanded: {
      type: Boolean,
      default: false
    },
    configurationId: {
      type: String,
      default: 'default'
    }
  },
  data() {
    return {
      optionsModalOpen: false,
      aktOptionsModalOpen: false,
      modalResolve: () => {},
    }
  },
  computed: {
    ...mapState({
      clinic: state => state.auth.clinic,
      patient: state => state.patient.patient,
      rights: state => state.auth.rights,
      branchId: state => state.auth.branch,
      doctors: state => state.calendar.doctors,
      successVisitSavedCounter: state => state.datatable.successVisitSavedCounter,
      visitToRecover: state => state.datatable.visitToRecover,
      loading: state => state.dom.loading,
      user: state => state.auth.user,
    }),
    isPatient() {
      return this.$store.getters.isPatient
    },
    isActive() {
      return this.object.status != 2
    },
    belongsToCurrentBranch() {
      if(!this.object) return false
      if(!this.object.branch_id) return true
      return this.object.branch_id == this.branchId
    },
    canDelete() {
      return this.rights.includes('recording_status')
    },
    additional() {
      return this.clinic.clinic_additional
    },
    hasRepresentative() {
      return this.patient?.representative_id || this.patient?.representative_fio
    },
    signerOptions() {
      return [
        { id: 'patient', title: this.$t('patient') },
        { id: 'representative', title: this.$t('representative_noun') },
      ]
    },
    canEditRecords() {
      if(this.rights.includes('add_records')) return true
      if(this.object?.doctor_id === this.user.id && this.rights.includes('edit_own_records')) {
        return true
      }
      return false
    },
    shortVersion() {
      return this.configurationId === 'visitsHistory'
    }
  },
  methods: {
    ...mapActions([
      'getDoctors',
    ]),
    agreementPressed() {
      this.$store.commit('setPrintAgreements', true)
      this.$store.commit('setVisit', copyObject(this.object))
      this.$bvModal.show('contract-modal')
    },
    payment() {
      this.$store.commit('setVisit', copyObject(this.object))
      this.$nextTick(() => {
        this.$bvModal.show('visit-pay-modal')
      })
    },
    printVisit() {
      let link = JwtService.getPrintPrelink(this.clinic)
      window.open(`${link}/document/${this.object.client_id}/disease_history?visit_id=${this.object.id}&branchId=${this.object.branch_id}`, '_blank')
    },
    async printAkt(signer, date = '') {
      let patientSigner = ''
      if(this.hasRepresentative) {
        patientSigner = await this.openOptionsModal()
        if(!patientSigner) return
      }
      let link = JwtService.getPrintPrelink(this.clinic)
      window.open(`${link}/akt/${this.object.id}?signer=${signer}&patientSigner=${patientSigner}&date=${date}`, '_blank')
    },
    async openOptionsModal() {
      this.optionsModalOpen = true
      await this.$nextTick()
      this.$bvModal.show('options-popup-modal')
      return new Promise((resolve) => {
        this.modalResolve = resolve
      });
    },
    async openAktOptionsModal() {
      const res = await this.getOptionsForAkt()
      setTimeout(() => {
        this.aktOptionsModalOpen = false
      }, 200)
      if(!res || !res.signer || !res.date) return
      await this.printAkt(res.signer, res.date)
    },
    async getOptionsForAkt() {
      this.aktOptionsModalOpen = true
      await this.$nextTick()
      this.$bvModal.show('akt-options-popup-modal')
      return new Promise((resolve) => {
        this.modalResolve = resolve
      })
    },
    async cancelRecoverVisit() {
      if(this.isActive) {
        let reason = ''
        if(this.additional.ask_reason_cancel) {
          reason = await this.showReasonPrompt()
          if(!reason) return
        }
        CalendarService.cancelRecord(this.object.id, reason).then(() => {
          this.$noty.info(this.$t('success_message'))
          this.$store.commit('incrementDataTableCounter')
        })
      }
      if(!this.isActive) {
        try {
          await CalendarService.recoverRecord(this.object.id)
          this.$noty.info(this.$t('success_message'))
          this.$store.commit('incrementDataTableCounter')
        } catch (e) {
          console.log(e)
          await this.quickView(true)
        }
      }
    },
    onlineBookingLinks() {
      this.$store.commit('setVisit', copyObject(this.object))
      this.$bvModal.show('visit-online-booking-links-modal')
    },
    async quickView(visitToRecover = false) {
      this.$store.commit('setVisitToRecover', visitToRecover ? this.object.id : null)
      if(!this.doctors.length) {
        await this.getDoctors(this.branchId)
      }
      this.$store.commit('setNewVisit', {
        id: this.object.id,
        client_id: this.object.client_id,
        doctor_id: this.object.doctor_id
      })
      this.$bvModal.show('add-new-visit-modal')
    },
    async toggleReview() {
      if(this.loading) return
      try {
        const newVal = this.object.reviewed_at ? '' : moment().format('YYYY-MM-DD HH:mm:ss')
        const res = await EloquentService.patch('record', this.object.id, {
          reviewed_at: newVal,
        })
        if(res.data) {
          this.object.reviewed_at = newVal
        }
      } catch (e) {
        console.error(e)
      }
    }
  },
  mounted() {
    if(this.visitToRecover === this.object.id) {
      this.$store.commit('setVisitToRecover', null)
      this.cancelRecoverVisit()
    }
  }
}
</script>
